import React, { FunctionComponent, useCallback } from 'react'
import { getIn, FormikErrors } from 'formik'
import classNames from 'classnames'

export interface Props {
  className?: string
  name: string | string[]
  errors?: FormikErrors<unknown> | null
  textAlign?: 'left' | 'right'
}

const FormError: FunctionComponent<Props> = ({
  className,
  name,
  errors,
  textAlign = 'left',
}) => {
  const getError = useCallback(
    (err: unknown, n: string | string[]): string | null => {
      const e = getIn(err, n)
      if (typeof e === 'string') {
        return e
      }

      if (e !== null && typeof e === 'object') {
        const firstKey = Object.keys(e)[0]
        return getError(e[firstKey], firstKey)
      }
      return null
    },
    []
  )

  const error = Array.isArray(name)
    ? // find first error
      name.reduce((err, n) => {
        if (!err) {
          return getError(errors, n) ?? ''
        }
        return err
      }, '')
    : getError(errors, name)

  return (
    <div
      className={classNames(
        'text-xs text-red-800 mt-xs',
        error ? 'block' : 'hidden',
        `text-${textAlign}`,
        className
      )}
    >
      {error}
    </div>
  )
}

export default React.memo(FormError)
